import Swiper from 'swiper';


function init_slider() {
  var swiper = new Swiper('.swiper-container', {
    slidesPerView: 'auto',
    slidesPerView: 2,
    centeredSlides: true,
    spaceBetween: 10,
    speed: 300,
    loop: true,
    autoplay: {
      delay: 8000,
      disableOnInteraction: false
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    }
  });
}

$(document).ready(init_slider)
$(document).on('page:load turbolinks:load', init_slider)
